<template>
	<v-container class="pt-6">
	  <v-row>

	  	<!-- Información básica del grupo -->
	  	<v-col cols="12" sm="10" md="10" lg="8" class="pb-1 mt-15">
	  		<v-card class="elevation-0 shadowCard">
	  			<v-card-text>
	  				<v-row>
	  					<v-col cols="9">
	  						<div>
			            <p class="mb-0 font-weight-bold">
			              {{ getGrupo.grupo.grupo_corto }}
			            </p>

			            <h5 class="mb-0 font-weight-bold text-h6 colorCurso" >
			              {{ getGrupo.escuela.curso }}<br/>
			            </h5>
		              <span class="text-sm font-weight-bolder grey--text">
		                <strong>{{ getGrupo.grupo.hora_inicio }} a {{ getGrupo.grupo.hora_fin }}</strong>
		              </span>
			          </div>
	  					</v-col>

	  					<v-col cols="2">
		            <v-avatar
			            size="60"
			            color="transparent"
			            rounded
			            class="elevation-1 avatares shadowCard"
			          >
			            <span class="text-h4 white--text">{{ getGrupo.grupo.id_nivel }}</span>
			          </v-avatar>
	  					</v-col>
	  				</v-row>
	  			</v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <v-row>	

	  	<!-- Boton para ir a los recusos -->
	  	<v-col cols="12" sm="10" md="10" lg="8" class="pb-1">
	  		<v-card class="shadowCard">
	  			<v-card-text>
	  			  <v-radio-group
              row
              value="1"
            >
              <v-radio
                color="green"
                value="1"
                label="Con participación"
              ></v-radio>
              <v-radio
                color="red"
                value="1"
                label="Sin participación"
              ></v-radio>
              <!-- <v-radio
                color="yellow darken-2"
                value="1"
                label="Retardo"
              ></v-radio>
              <v-radio
                color="orange"
                value="1"
                label="Sin participación"
              ></v-radio> -->
            </v-radio-group>

            <v-row>
            	<v-col cols="12" md="6" lg="4">
		            <v-menu
					        ref="menu"
					        v-model="menu"
					        :close-on-content-click="false"
					        :return-value.sync="fecha"
					        transition="scale-transition"
					        offset-y
					        min-width="auto"
					      >
					        <template v-slot:activator="{ on, attrs }">
					          <v-text-field
					            v-model="fecha"
					            label="Fecha de asistencia"
					            append-icon="mdi-calendar"
					            readonly
					            v-bind="attrs"
					            v-on="on"
					            filled
					          ></v-text-field>
					        </template>
					        <v-date-picker
					          v-model="fecha"
					          no-title
					          scrollable
					          :allowed-dates="fechasHabiles"
					          :min="fechaMin"
      							:max="fechaMax"
      							color="primary"
					        >
					          <v-spacer></v-spacer>
					          <v-btn
					            text
					            color="primary"
					            @click="menu = false"
					          >
					            Cancel
					          </v-btn>
					          <v-btn
					            text
					            color="primary"
					            @click="$refs.menu.save(fecha),getAlumnos()"
					          >
					            Ok
					          </v-btn>
					        </v-date-picker>
					      </v-menu>

            	</v-col>
            </v-row>

	  			</v-card-text>
	  			<v-data-table
				    :headers="headers"
				    :items="listaalumnos"
				    :items-per-page="listaalumnos.length"
				    class="elevation-0"
				    hide-default-footer
				    :mobile-breakpoint="100"
				  >
				  	<!-- Avatar -->
				  		<template v-slot:item.alumno="{ item }">
				  		<div class="d-flex  my-2">
				  			<div v-if="item.tipo !== 1">
				  			  <v-avatar
				        	  size="45"
				        	  color="transparent"
				        	>
				            <avataaars
				            	v-if="item.idavatar != null"
					          	:accessoriesType="item.accessoriesType"
						        	:isCircle="true"
								      :clotheType="item.clotheType"
						        	:clotheColor="item.clotheColor"
								      :eyebrowType="item.eyebrowType"
								      :eyeType="item.eyeType"
								      :facialHairColor="item.facialHairColor"
						        	:facialHairType="item.facialHairType"
								      :graphicType="item.graphicType"
								      :mouthType="item.mouthType"
						        	:skinColor="item.skinColor"
						        	:topType="item.topType"
						        	:topColor="item.topColor"
								      :hairColor="item.hairColor"
								      :circleColor="'#6fb8e0'">
								    </avataaars>
							    	<avataaars v-else></avataaars>
				        	</v-avatar>
				        	<br/>
		              <span class="text-caption">{{ item.alumno }}</span>
		            </div>
		            <div v-else>
		            	Valor
		            </div>
		          </div>
				    </template>

				    <!-- Valor asistencia -->
				    <template v-slot:item.asistencia="{ item }">
				    	<div v-if="item.tipo !== 1">
				    		<v-radio-group
		              row
		              v-model="item.valor_asistencia"
		            >
		              <v-radio
		                color="green"
		                :value="1"
		              ></v-radio>
		              <v-radio
		                color="red"
		                :value="2"
		              ></v-radio>
		              <!-- <v-radio
		                color="yellow darken-2"
		                :value="3"
		              ></v-radio>
		              <v-radio
		                color="orange"
		                :value="4"
		              ></v-radio> -->
		            </v-radio-group>
				    	</div>
				    	<div v-else>
				    		<v-radio-group
		              row
		              value="1"
		            >
					    		<v-radio
		                color="green"
		                value="1"
		              ></v-radio>
					    		<v-radio
		                color="red"
		                value="1"
		              ></v-radio>
					    		<!-- <v-radio
		                color="yellow darken-2"
		                value="1"
		              ></v-radio>
					    		<v-radio
		                color="orange"
		                value="1"
		              ></v-radio> -->
		            </v-radio-group>
				    	</div>
				    </template>

				    <template v-slot:item.fecha_pago="{ item }">
			        <v-chip color="success" small v-if="!item.fecha_pago" @click="editFechaPago( item )"> Fecha de reinscripción </v-chip>
			        <span color="success" v-else >{{ item.fecha_pago }}</span>
			      </template>
				  </v-data-table>
				  <v-card-actions>
				    <v-btn class="btn-grad text-capitalize" rounded 
		  				large 
		  				dark 
		  				block 
		  				@click="enviarAsistencias()" 
		  				:disabled="disabled || loading || enviarAsistenciaEnCurso"
		  				:loading="loading"
		  			>
		  				<span >Guardar</span>
		  			</v-btn>
				  </v-card-actions>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <v-dialog
      v-model="dialogFecha"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          Fecha próximo pago
        </v-card-title>
        <v-card-text>
        	<v-text-field
        	  name="name"
        	  label="Fecha de pago"
        	  v-model="fecha_pago"
        	  type="date"
        	></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            dark
            rounded
            small
            @click="dialogFecha = false, alumno = null "
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            rounded
            small
            @click="saveFecha()"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


	  <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>

	  <v-speed-dial
      top
      left
      fixed
    >
      <template v-slot:activator>
        <v-btn
          color="white"
          fab
          :to="{ name: 'DetalleGrupoTeacher' }"
        >
          <v-icon color="primary">
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

	</v-container>
</template>
<script>
	// importar librerías
	import { mapGetters, mapActions } from 'vuex'

	// Componentes
  import Alerta        from '@/components/alertas/Alerta.vue'
  import Loader        from '@/components/alertas/Loader.vue'

  import Avataaars     from 'vuejs-avataaars'
  
  const  base64 = require('base-64');

	export default {
	  name: "dashboard-default",
	  data: () => ({
    	respuestaAlerta: false,

      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},

     	listaalumnos: [],
      model: null,

      headers: [
        { text: 'Alumno'        , value: 'alumno'    , class: 'secondaryText--text text-caption sizeFont' },
        { text: 'Participación' , value: 'asistencia', class: 'secondaryText--text text-caption sizeFont' },
        { text: 'Fecha pago'    , value: 'fecha_pago', class: 'secondaryText--text text-caption sizeFont' },
      ],

      snack: false,
      snackColor: '',
      snackText: '',

      disabled:false,
			loading:false,
      /** Evita doble envío (mismo tick o doble toque) antes de que Vue pinte :loading */
      enviarAsistenciaEnCurso: false,
			fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

			alumno: null,
			dialogFecha: false,
			fecha_pago:null,
			menu: false,
			fechaMin:null,
			fechaMax:null,
			fechas:[]
	  }),

	  components: {
	    Alerta,
	    Loader,
	    Avataaars
	  },

	  async created ( ){
	  	await this.fechasGrupo( )
    	await this.getAlumnos( )
    },

	  computed:{
	  	...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS' ])
	  },

	  methods:{
	  	...mapActions( 'login', [ 'abrirRecursosAlumno', 'abrirCalificaciones' ] ),

	  	fechasGrupo( ){
    		this.cargar = true
  			// Preparamos el id del teacher
    		const id_grupo = base64.encode( this.getGrupo.grupo.id )

    		const payload = {
    			id_grupo: base64.encode( this.getGrupo.grupo.id ),
    			id_nivel: this.getGrupo.grupo.id_nivel
    		}

  			// Hacemos la consulta
  			this.fechas = []
    		return this.$http.post('grupos.fechas.habiles', payload ).then( response=> {
    			this.fechaMin = response.body[0]
    			this.fechaMax = response.body[ response.body.length - 1]
    			this.fechas   = response.body
    			this.fecha    = this.fechaMax
    		}).catch( error =>{
    			this.disabled = true
    			this.validarError( error )
    		}).finally( () => { this.cargar = false })
	  	},

	  	fechasHabiles ( val ){
	  		return this.fechas.includes( val ) 
	  	},

	  	getAlumnos ( ){
	  		this.listaalumnos = []
    		this.cargar = true
  			// Preparamos el id del teacher
    		const id_grupo = base64.encode( this.getGrupo.grupo.id )

    		const payload = {
    			id_grupo: base64.encode( this.getGrupo.grupo.id ),
    			fecha: this.fecha,
    			id_nivel: this.getGrupo.grupo.id_nivel
    		}

  			// Hacemos la consulta
    		this.$http.post('grupos.asistencias', payload ).then( response=> {
    			this.listaalumnos = response.body
    			this.disabled = false
    			this.listaalumnos.unshift({alumno:'Valor', asistencia:'', tipo: 1}) // para poder poner los colores de la asistencia
    		}).catch( error =>{
    			this.disabled = true
    			this.validarError( error )
    		}).finally( () => { this.cargar = false })
    	},

    	validarError ( value ) {
        this.cargar = false 
        if( value.status == 400 || value.status == 500){
          this.parametros.mensaje      = value.body.message
          this.parametros.dialogError  = true 
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true 
        }
      },

      saveFecha() {
      	this.cargar = true
    		const payload = {
    			id_asistencia: this.alumno.id_asistencia,
    			fecha_pago:    this.fecha_pago,
    		}
  			// Hacemos la consulta
    		this.$http.post('grupos.asistencias.add.fechapago', payload ).then( response=> {
    			this.dialogFecha = false
    			this.alumno = null
    			this.fecha_pago = null
    			this.cargar = false 
          this.parametros.mensaje      = response.body.message
          this.parametros.dialogError  = true 
          this.parametros.color        = 'success'
          this.respuestaAlerta         = true 
    			this.getAlumnos()
    		}).catch( error =>{
    			this.validarError( error )
    		}).finally( () => { this.cargar = false })
      },

      enviarAsistencias( ){
    		if (this.enviarAsistenciaEnCurso) return
    		this.enviarAsistenciaEnCurso = true
    		this.cargar = true
    		this.loading = true
    		const asistencias = this.listaalumnos.filter((row) => row.tipo !== 1)
    		const payload = {
    			id_grupo:    base64.encode( this.getGrupo.grupo.id ),
    			fecha:       this.fecha,
    			id_nivel:    this.getGrupo.grupo.id_nivel,
    			asistencias,
    			id_teacher:  this.getUsuarioLMS.id
    		}
  			// Hacemos la consulta
    		this.$http.post('grupos.asistencias.add', payload ).then( response=> {
    			this.cargar = false 
          this.parametros.mensaje      = response.body.message
          this.parametros.dialogError  = true 
          this.parametros.color        = 'success'
          this.respuestaAlerta         = true 
    			this.getAlumnos()
    		}).catch( error =>{
    			this.validarError( error )
    		}).finally( () => {
    			this.cargar = false
    			this.loading = false
    			this.enviarAsistenciaEnCurso = false
    		})
      },

      editFechaPago( alumno ){
      	this.alumno = alumno
      	this.dialogFecha = true
      },

	  }
	};
</script>

<style scoped>
	.avatares{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.1)  !important;
	}

	.colorCurso{
		color: #006093;
	}

	.styleText{
    font-weight:  bolder !important;
  }

  .font{
  	font-family: 'Open Sans' !important;
  }

  .btn-grad {
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

</style>
